export const FETCH_TASK = 'task/FETCH_TASK';
export const FETCH_TASK_INFO = 'task/FETCH_TASK_INFO';
export const FETCH_TITLE_TASK = 'task/FETCH_TITLE_TASK';
export const FETCH_PAYMENT_TASK = 'task/FETCH_PAYMENT_TASK';
export const FETCH_CONCESSION_TASK = 'task/FETCH_CONCESSION_TASK';
export const FETCH_NEGOTIATION_TASK = 'task/FETCH_NEGOTIATION_TASK';